// Generated by ReScript, PLEASE EDIT WITH CARE

import * as SentryJs from "./Sentry.js";
import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";

function init(prim) {
  SentryJs.init(prim);
}

function captureException(prim) {
  return SentryJs.captureException(prim);
}

function captureExceptionWithContext(prim0, prim1) {
  return SentryJs.captureException(prim0, prim1);
}

function captureSentryException(err_msg) {
  SentryJs.captureException(ErrorUtils$Catalyst.resolveError(ErrorUtils$Catalyst.getDefaultErrorEntity(err_msg, undefined, undefined)));
}

function captureSentryExceptionWithContext(error_msg, payload) {
  SentryJs.captureException(ErrorUtils$Catalyst.resolveError(ErrorUtils$Catalyst.getDefaultErrorEntity(error_msg, undefined, undefined)), payload);
}

export {
  init ,
  captureException ,
  captureExceptionWithContext ,
  captureSentryException ,
  captureSentryExceptionWithContext ,
}
/* ./Sentry.js Not a pure module */
